export const DEPARTMENT_OPTIONS = [
  'KYC',
  'KYC- Product',
  'RMS',
  'Updation',
  'Accounts',
  'Infosec',
  'Tech',
  'Compliance',
  'DP',
  'Legal',
  'CS',
  'PMLA',
  'AP Audit',
  'AP Business',
  'AP registration',
  'FDS',
  'Research',
  'IA',
  'PMS',
  'MF',
  'IRDAI',
  'PFRDA',
  'Advertisement',
  'IFSCA'
];

export const LEGAL_UPDATE_DEPARTMENT_OPTIONS = [...DEPARTMENT_OPTIONS, 'Others'];
